import { Row } from "@budibase/types"

export type UIRow = Row & {
  _id: string
}
